export default __webpack_public_path__ + "static/media/Confraria-Manga-Rosa.7f256c44.png";